import React, { useState, useEffect, useContext } from "react";
import { CheckCheck, Trash2 } from "lucide-react";
import CustomerMasterLayout from "../../../../layouts/customer/CustomerMasterLayout";
import "../../../../assets/styles/customer/CustomerNotifications.css";
import AppContext from "../../../../context/AppContext";
import axios from "axios";

const CustomerNotifications = () => {
  const [apiNotifs, setApiNotifs] = useState([]);
  const { baseUrl } = useContext(AppContext);

  // ✅ FIX: localStorage mein customer data 'admin' key ke andar JSON object hai
  // e.g. admin = {"id":1,"fullName":"hamza",...}
  // Is se customerId nikalna:
  const getCustomerId = () => {
    try {
      // Pehle direct keys try karo
      const direct =
        localStorage.getItem("customerId") ||
        localStorage.getItem("customer_id") ||
        localStorage.getItem("mwcustomer_id");
      if (direct) return direct;

      // Tumhari app 'admin' key mein customer object store karti hai
      const adminRaw = localStorage.getItem("admin");
      if (adminRaw) {
        const adminObj = JSON.parse(adminRaw);
        if (adminObj?.id) return String(adminObj.id);
      }

      // Fallback: 'customer' key try karo
      const customerRaw = localStorage.getItem("customer");
      if (customerRaw) {
        const customerObj = JSON.parse(customerRaw);
        if (customerObj?.id) return String(customerObj.id);
      }

      return null;
    } catch (e) {
      console.error("localStorage parse error:", e);
      return null;
    }
  };

  const customerId = getCustomerId();

  // ✅ FIX: status field use karo is_read ki jagah (DB mein 'status' column hai)
  const unreadCount = apiNotifs.filter((n) => n.status === "unread").length;

  /* ── fetch ── */
  const viewAllNotifications = (id) => {
    const formData = new FormData();
    formData.append("customer_id", id);

    axios
      .post(`${baseUrl}/customer/notification/viewAllNotifications`, formData)
      .then((res) => {
        console.log("Notification API response:", res.data);
        if (res.data.success) setApiNotifs(res.data.notification);
      })
      .catch((err) => console.log("API error:", err.message));
  };

  useEffect(() => {
    console.log("customerId used:", customerId);

    if (customerId) {
      viewAllNotifications(customerId);
    } else {
      console.log("ERROR: customerId null — localStorage check karo");
    }
  }, []);

  /* ── mark all read ── */
  const markAllRead = () => {
    const formData = new FormData();
    formData.append("customer_id", customerId);

    axios
      .post(`${baseUrl}/customer/notification/markAllRead`, formData)
      .then((res) => {
        if (res.data.success)
          // ✅ FIX: is_read → status
          setApiNotifs((prev) => prev.map((n) => ({ ...n, status: "read" })));
      })
      .catch((err) => console.log(err.message));
  };

  /* ── mark single read ── */
  const markRead = (id) => {
    // ✅ FIX: is_read → status
    setApiNotifs((prev) =>
      prev.map((n) => (n.id === id ? { ...n, status: "read" } : n)),
    );
  };

  /* ── clear all ── */
  const clearAll = () => {
    const formData = new FormData();
    formData.append("customer_id", customerId);

    axios
      .post(`${baseUrl}/customer/notification/clearAllNotifications`, formData)
      .then((res) => {
        if (res.data.success) setApiNotifs([]);
      })
      .catch((err) => console.log(err.message));
  };

  return (
    <CustomerMasterLayout>
      <div className="cnotif-wrapper">
        <div className="cnotif-header">
          <div>
            <h1 className="cnotif-title">Notifications</h1>
            <p className="cnotif-subtitle">
              {unreadCount > 0
                ? `${unreadCount} unread notification${unreadCount > 1 ? "s" : ""}`
                : "All caught up!"}
            </p>
          </div>

          <div style={{ display: "flex", gap: "8px" }}>
            {unreadCount > 0 && (
              <button className="cnotif-markall-btn" onClick={markAllRead}>
                <CheckCheck size={15} className="me-1" /> Mark All as Read
              </button>
            )}
            {apiNotifs.length > 0 && (
              <button
                className="cnotif-markall-btn"
                onClick={clearAll}
                style={{ background: "rgba(239,68,68,0.1)", color: "#ef4444" }}
              >
                <Trash2 size={15} className="me-1" /> Clear All
              </button>
            )}
          </div>
        </div>

        <div className="cnotif-card">
          {apiNotifs.length === 0 && (
            <p style={{ textAlign: "center", padding: "2rem", color: "#888" }}>
              No notifications
            </p>
          )}

          {apiNotifs.map((n, i) => (
            <div
              key={n.id}
              // ✅ FIX: !n.is_read → n.status === 'unread'
              className={`cnotif-item${n.status === "unread" ? " cnotif-item--unread" : ""}${i < apiNotifs.length - 1 ? " cnotif-item--bordered" : ""}`}
              onClick={() => markRead(n.id)}
            >
              <div
                className="cnotif-item__icon-wrap"
                style={{ background: "rgba(62,150,231,0.1)" }}
              >
                <i
                  className="bi bi-bell-fill"
                  style={{ color: "var(--secondary-color)" }}
                />
              </div>
              <div className="cnotif-item__body">
                <div className="cnotif-item__title-row">
                  <span className="cnotif-item__title">{n.title}</span>
                  {/* ✅ FIX: !n.is_read → n.status === 'unread' */}
                  {n.status === "unread" && (
                    <span className="cnotif-item__dot" />
                  )}
                </div>
                <p className="cnotif-item__desc">{n.description}</p>
                <p className="cnotif-item__date">{n.created_at}</p>
              </div>
              <button
                className="cnotif-item__check"
                title="Mark as read"
                onClick={(e) => {
                  e.stopPropagation();
                  markRead(n.id);
                }}
              >
                <i className="bi bi-check-circle" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </CustomerMasterLayout>
  );
};

export default CustomerNotifications;
